/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2022, Zumper
 * @description mainMap selectors
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectMainMapData = (state: State) => state.mainMap.data
export const selectMainMapMeta = (state: State) => state.mainMap.meta

export const selectMapDimensions = compose(
  (data) => ({ width: data.width, height: data.height }),
  selectMainMapData
)

export const selectMapUnsynced = compose((meta) => meta.unsynced, selectMainMapMeta)
